import React from 'react'
import "./connect.css"
import { FiArrowLeftCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom'

function Connect() {
  return (
    <div className='connect_bg'>
             <Link to='/userhome'><h1 className='connect_leftbtn'><FiArrowLeftCircle/> </h1> </Link>
    </div>
  )
}

export default Connect